module.exports = __webpack_public_path__ + "img/bell-gray.32da8f23.svg";